import axios from '../utils/axios'

const getAll = () => {
    return new Promise((resolve, reject) => {
        axios.get('/api/templates')
            .then(({ data: { data } }) => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
    })
}

export {
    getAll
}
